import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';
import { ChartsService, Type } from 'src/app/services/charts.service';
import { Color, NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';
import { catchError, finalize, of } from 'rxjs';
import { LoggingService } from 'src/app/services/logging.service';
import { Area } from 'src/app/models/chart.model';
import { IconsComponent } from 'src/app/components/icons/icons.component';

@Component({
  selector: 'app-pie',
  standalone: true,
  imports: [NgxChartsModule, IconsComponent],
  templateUrl: './pie.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PieComponent implements OnInit {
  public investmentProjectId = input<string>('');
  public chartFor = input.required<Type>();

  public ngOnInit(): void {
    this.loading.update(() => true);
    this.chartsService
      .fetchAreas(this.investmentProjectId(), this.chartFor())
      .pipe(
        catchError((error) => {
          this.logger.error({ message: $localize`Fetch areas error`, error });

          return of({ totalArea: 0, protectedArea: 0 });
        }),
        finalize(() => this.loading.update(() => false)),
      )
      .subscribe((areas) => {
        this.results.set([
          { name: 'Restored', value: (Math.round(areas.totalArea * 100) / 100).toFixed(2) },
          { name: 'Protected', value: (Math.round(areas.protectedArea * 100) / 100).toFixed(2) },
        ]);
      });
  }

  public formatValue(value: number): string {
    return (Math.round(value * 100) / 100).toFixed(2);
  }

  public formatPercent(value: number): string {
    return (Math.round(value * 100) / 100).toFixed(1);
  }

  private readonly chartsService = inject(ChartsService);
  private readonly logger = inject(LoggingService);

  public loading = signal<boolean>(false);
  public results = signal<Area[]>([]);
  public gradient = signal<boolean>(true);
  public colorScheme = signal<string | Color>({
    name: '',
    group: ScaleType.Time,
    selectable: true,
    domain: ['#5b8666', '#A10A28'],
  });
}
